import { apiCweb } from './api-cweb';
import { appLog } from '~src/utils/log';
import { DbCommit, DbFolder, DbID, DbProject } from '~src/types/db';

interface LoadTemplatesParams {
  projectId: DbProject['id'];
  skip?: number;
  take?: number;
}

export const loadTemplates = async (
  key,
  { projectId, skip, take }: LoadTemplatesParams
) => {
  appLog('loadTemplates -> ', { projectId });
  const res = await apiCweb.get<DbProject[]>(
    `/projects/${projectId}/templates`,
    { params: { skip: skip, take: take } }
  );
  return res.data;
};

interface LoadTemplateFoldersParams {
  projectId: DbProject['id'];
  templateId: string;
  showDeleted?: boolean;
  skip?: number;
  take?: number;
}

export const loadTemplateFolders = async (
  key,
  { projectId, templateId, showDeleted, skip, take }: LoadTemplateFoldersParams
) => {
  appLog('loatFolderTemplates -> ', { projectId, templateId });
  const res = await apiCweb.get<DbFolder[]>(
    `projects/${projectId}/templates/${templateId}/folders`,
    { params: { skip: skip, take: take } }
  );
  return res.data;
};

interface CreateTemplateParams {
  projectId: DbProject['id'];
  templateData: Pick<DbProject, 'name' | 'start_date' | 'is_active'>;
}

export const createTemplate = async ({
  templateData,
  projectId,
}: CreateTemplateParams) => {
  appLog('createTemplate -> ', { templateData, projectId });
  const { name, start_date, is_active } = templateData;
  const res = await apiCweb.post<DbProject>(`projects/${projectId}/templates`, {
    name,
    is_active,

    is_archive_on: true,
  });
  return res.data;
};

interface CreateTemplateFolderParams {
  folderData: Pick<
    DbFolder,
    'name' | 'description' | 'is_locked' | 'is_favorite' | 'parent_id' | 'state'
  >;
  projectId: DbProject['id'];
  templateId: DbID;
  commit_id?: DbCommit['id'];
}

export const createTemplateFolder = async ({
  folderData,
  projectId,
  templateId,
  commit_id,
}: CreateTemplateFolderParams) => {
  appLog('createTemplateFolder -> ', { folderData, projectId, templateId });
  const res = await apiCweb.post<DbFolder>(
    `projects/${projectId}/templates/${templateId}/folders`,
    folderData,
    { params: { commit_id: commit_id } }
  );
  return res.data;
};

// Get single template
interface LoadTemplateParams {
  projectId: DbProject['id'];
  templateId: string;
}

export const loadTemplate = async (
  key,
  { projectId, templateId }: LoadTemplateParams
) => {
  appLog('loadTemplate -> ', { projectId, templateId });
  const res = await apiCweb.get<DbProject>(
    `/projects/${projectId}/templates/${templateId}`
  );
  return res.data;
};

// Get template archive folder structure
interface LoadTemplateArchiveFolderStructureParams {
  projectId: DbProject['id'];
  templateId: string;
  skip?: number;
  take?: number;
  sort?: string;
}

export const loadTemplateArchiveFolderStructure = async (
  key,
  {
    projectId,
    templateId,
    skip,
    take,
    sort,
  }: LoadTemplateArchiveFolderStructureParams
) => {
  appLog('loadTemplateArchiveFolderStructure -> ', { projectId, templateId });
  const res = await apiCweb.get<DbFolder[]>(
    `/projects/${projectId}/templates/${templateId}/archive_folder_structure`,
    { params: { skip, take, sort } }
  );
  return res.data;
};

// Get template initialize payload
interface LoadTemplateInitializePayloadParams {
  projectId: DbProject['id'];
  templateId: string;
  parent_folder_id?: number;
}

export const loadTemplateInitializePayload = async (
  key,
  {
    projectId,
    templateId,
    parent_folder_id,
  }: LoadTemplateInitializePayloadParams
) => {
  appLog('loadTemplateInitializePayload -> ', {
    projectId,
    templateId,
    parent_folder_id,
  });
  const res = await apiCweb.get(
    `/projects/${projectId}/templates/${templateId}/archive_folders/initialize_payload`,
    { params: { parent_folder_id } }
  );
  return res.data;
};
